/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCubeEmpty: {
  name: 'cube-empty';
  data: string;
} = {
  name: 'cube-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.67.776a1.5 1.5 0 0 0-1.34 0l-5 2.5a1.5 1.5 0 0 0-.83 1.342v6.764a1.5 1.5 0 0 0 .83 1.342l5 2.5a1.5 1.5 0 0 0 1.34 0l5-2.5a1.5 1.5 0 0 0 .83-1.342V4.618a1.5 1.5 0 0 0-.83-1.342l-5-2.5Zm-.894.895a.5.5 0 0 1 .448 0l4.9 2.45L8 6.451 2.875 4.12l4.901-2.45ZM2.5 5.049v6.333a.5.5 0 0 0 .276.447L7.5 14.191V7.322l-5-2.273Zm6 9.142 4.724-2.362a.5.5 0 0 0 .276-.447V5.049l-5 2.273v6.869Z" fill="currentColor"/></svg>`,
};
